import styled from "styled-components";

interface Props {
  disabled?: boolean
}

export const CancelButtonWrapper = styled.div`
  margin-right: 10px;
`

export const CustomForm = styled.form`
  width: 100%; 
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
`

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const DropdownPlaceholder = styled.div`
  font-weight: normal;
  color: #616161;
`

export const FormLabel = styled.div<Props>`
  padding: 0 2px;
  color: ${({disabled}) => disabled ? "#C8C6C4" : "#616161"};
  font-size: 14px;
`

export const StyledEmptyField = styled.div`
  font-size: 10px;
  color: #A4262C;
  width: 250px;
  padding: 0 2px;
`

export const RecognitionLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
